module.exports = __webpack_public_path__ + "static/media/ic-history.16f2f6dc.svg";